import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrinterOutlined, ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import CollectionReportFilters from "./components/CollectionReportFilters";
import CollectionReportTable from "./components/CollectionReportTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportCollectionReportCsv } from "./components/exportCollectionReportCsv";
import { selectAuthInfo } from "../../Auth/authSelectors";

const { Title } = Typography;

const CollectionReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
   const authInfo  = useSelector(selectAuthInfo);
  const { list, receipts, filters } = useSelector((state) => state.collectionReport);

  const reportRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Collection Report",
    removeAfterPrint: true,
  });

  const handleNavigateBack = () => {
    navigate("/reports");
  };
  const handleDownloadCsv = () => {
    exportCollectionReportCsv({
      list,
      receipts,
      filters,
      authInfo,
      title:    "Sales Paid & Collection Record",
      filename: "collection_report",
    });
  };

  const hasData = list.length > 0 || receipts.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateBack}
                style={{ marginRight: 8 }}
              />
              <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >
                Sales Paid & Collection Record
              </Title>
            </div>
          }
          extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <CollectionReportFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <CollectionReportTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Sales Paid & Collection Report"
          mode="report-page"
          renderTable={() => (
            <CollectionReportTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default CollectionReport;
